import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #d6d6d6;
  height: auto;
  margin-top: 2em;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    padding: 3em 0;
    margin: 0;
  }
`;

export const TimelineContainer = styled.div`
  width: 100%;

  @media (max-width: 900px) {
    margin: 1em;
  }
`;

export const TimelineLogo = styled.img`
  border-radius: 5em;
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  left: 0;
  top: 0;
`;

export const Text = styled.h1`
  font-size: 1.6em;
  text-align: center;
  margin: 1.5em 0;

  @media (max-width: 900px) {
    font-size: 1.3em;
  }
`;

export const BigText = styled.h1`
  font-size: 2.2em;
  text-align: center;
  margin-bottom: 1em;
  /* text-transform: uppercase; */
`;

export const RecentWorks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.6em;
`;

export const RecentWork = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 0.7em;
  margin: 0;
`;

export const Works = styled.a`
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: #d6d6d6;
  font-weight: 400;
  margin: 0;
  padding: 0;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }

  &:hover::after {
    width: 100%;
    transition: width 0.5s ease;
    transition-delay: 0.3s;
  }

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 0;
    width: 0;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.6);
  }
`;

export const DeprecatedText = styled.p`
  font-size: 0.6em;
  color: #d6d6d6;
  margin-left: 10px;
  display: flex;
`;

export const ExploratoryProjects = styled.div`
  display: flex;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const ProjectCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: none;
  padding: 16px;
  width: 30%;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const ProjectImage = styled.img`
  width: 100%;
  border-radius: 8px;
`;

export const ProjectTitle = styled.h2`
  font-size: 1.6em;
  margin: 0.7em;
`;

export const ProjectDescription = styled.p`
  font-size: 1.1em;
`;

export const MyWork = styled.div`
  margin: 3em 2em;

  @media (max-width: 900px) {
    margin: 3em 1em;
  }
`;

export const MoreWork = styled.a`
  margin-bottom: 2em;
  text-align: center;
  font-size: 1.4em;
  text-transform: uppercase;
  text-decoration: none;
  color: inherit;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    color: inherit;
  }
`;

export const Medium = styled.a`
  margin-bottom: 2.5em;
  font-size: 1.4em;
  text-decoration: none;
  text-align: center;
  color: inherit;
  text-transform: uppercase;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    color: inherit;
  }
`;

export const ProjectLink = styled.a`
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  vertical-align: middle;
  font-size: 1em;
  border: 1px solid #d6d6d6;
  border-radius: 2em;
  padding: 0.6em;

  &:hover {
    transition: 0.3s ease all;
    color: black;
    background-color: #d6d6d6;
  }
`;

export const ProjectRepository = styled.a`
  padding: 0.7em;
  text-decoration: none;
  color: inherit;
  font-size: 1.6em;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    color: inherit;
  }
`;
